export enum UserConsentsEvents {
    ExtendSessionRetention = 'session.extend-retention',
    UserConsentCreated = 'user-consent.created',
}
